export const KEY_ENTER = 13;
export const KEY_ESC = 27;
export const KEY_E = 69;
export const KEY_COMMA = 188;
export const KEY_DOT = 190;
